import styled from 'styled-components';

export const ValueDetailsListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
